import React, { useState, useEffect } from 'react';

// ─── TOKENS ──────────────────────────────────────────────────────────────────
const C = {
 accent:'#3AAF58', accentLight:'#EAF7EE',
 bg:'#F3F6F3', surface:'#FFFFFF',
 border:'#E2E8E2', border2:'#CDD8CD',
 text:'#1A2E1E', text2:'#3D5E44', text3:'#7A9A80',
 amber:'#D4840F', amberBg:'#FEF6E7', amberBorder:'#F0D499',
 red:'#C83333', redBg:'#FDEAEA',
 blue:'#2563A8', blueBg:'#EAF1FB',
 purple:'#6B48A8', purpleBg:'#F0EBFB',
 teal:'#1A7A7A', tealBg:'#E7F5F5',
};

const inr = n => '₹' + Number(n||0).toLocaleString('en-IN', { maximumFractionDigits: 0 });

// ─── DEFAULT PRICE DATA ───────────────────────────────────────────────────────
const DEFAULT_PRICES = {
 rooms: [
 { id:'forest_view', name:'Forest View Room', baseRate:4500, extraBed:1200, gstRate:12 },
 { id:'lakeside_suite', name:'Lakeside Suite', baseRate:8500, extraBed:1500, gstRate:12 },
 { id:'canopy_cottage', name:'Canopy Cottage', baseRate:12000,extraBed:2000, gstRate:18 },
 { id:'jungle_tent', name:'Jungle Tent', baseRate:3000, extraBed:1000, gstRate:12 },
 { id:'driver_room', name:'Driver / Staff Room', baseRate:1500, extraBed:0, gstRate:0 },
 ],
 mealPlans: [
 { id:'cp', name:'CP – Breakfast', ratePerPax:800 },
 { id:'map', name:'MAP – Breakfast + Dinner', ratePerPax:1500 },
 { id:'ap', name:'AP – All Inclusive (3 meals)',ratePerPax:2200 },
 { id:'lunch_only', name:'Lunch Only', ratePerPax:600 },
 { id:'dinner_only', name:'Dinner Only', ratePerPax:800 },
 { id:'high_tea', name:'High Tea', ratePerPax:350 },
 { id:'welcome_drink',name:'Welcome Drink', ratePerPax:120 },
 { id:'buffet_veg', name:'Buffet Lunch – Veg', ratePerPax:650 },
 { id:'buffet_nonveg',name:'Buffet Lunch – Non-Veg',ratePerPax:850},
 ],
 packages: [
 { id:'corp_std', name:'Corporate Day Picnic – Standard', ratePerPax:1800, gstRate:18, includes:'Welcome Drink, Breakfast, Buffet Lunch, High Tea, Activities' },
 { id:'corp_prem', name:'Corporate Day Picnic – Premium', ratePerPax:2800, gstRate:18, includes:'All Standard + DJ, Conference Hall, AV Setup, Bonfire' },
 { id:'school', name:'School Picnic Package', ratePerPax:950, gstRate:5, includes:'Welcome Drink, Lunch, 3 Activities' },
 { id:'weekend', name:'Weekend Room Package', ratePerPax:7500, gstRate:12, includes:'Room + Breakfast + Dinner + 1 Activity' },
 { id:'mice', name:'MICE Conference Package', ratePerPax:3500, gstRate:18, includes:'Hall, AV, 3 Meals, Team Activities' },
 ],
 venues: [
 { id:'central_lawn', name:'Central Lawn', baseRate:85000, capacity:1000, gstRate:18 },
 { id:'amphitheatre', name:'Jungle Amphitheatre', baseRate:55000, capacity:500, gstRate:18 },
 { id:'conf_hall_a', name:'Conference Hall A', baseRate:15000, capacity:100, gstRate:18 },
 { id:'conf_hall_b', name:'Conference Hall B', baseRate:8000, capacity:50, gstRate:18 },
 { id:'poolside', name:'Poolside Deck', baseRate:25000, capacity:150, gstRate:18 },
 { id:'banquet', name:'Banquet Hall', baseRate:45000, capacity:300, gstRate:18 },
 ],
 activities: [
 { id:'obstacle', name:'Obstacle Course', pricePerPax:350, capacity:50, duration:'45 min', gstRate:18 },
 { id:'rappelling',name:'Rappelling', pricePerPax:500, capacity:15, duration:'60 min', gstRate:18 },
 { id:'camel', name:'Camel Cart Ride', pricePerPax:200, capacity:20, duration:'30 min', gstRate:18 },
 { id:'bullock', name:'Bullock Cart Ride',pricePerPax:150, capacity:20, duration:'30 min', gstRate:18 },
 { id:'nature_walk',name:'Nature Walk', pricePerPax:100, capacity:30, duration:'60 min', gstRate:18 },
 { id:'zipline', name:'Zip Line', pricePerPax:400, capacity:10, duration:'20 min', gstRate:18 },
 { id:'archery', name:'Archery', pricePerPax:250, capacity:15, duration:'30 min', gstRate:18 },
 { id:'bonfire', name:'Bonfire & DJ Night',pricePerPax:300, capacity:200,duration:'180 min',gstRate:18 },
 ],
 addons: {
 adventure: [
 { id:'paintball', name:'Paintball', price:600, unit:'per pax', gstRate:18 },
 { id:'zipline', name:'Zip Line', price:400, unit:'per pax', gstRate:18 },
 { id:'rappelling',name:'Rappelling', price:500, unit:'per pax', gstRate:18 },
 { id:'atv', name:'ATV Ride', price:800, unit:'per pax', gstRate:18 },
 { id:'camel', name:'Camel Cart Ride',price:200, unit:'per pax', gstRate:18 },
 { id:'bullock', name:'Bullock Cart', price:150, unit:'per pax', gstRate:18 },
 ],
 entertainment: [
 { id:'dj_std', name:'DJ – Standard', price:25000,unit:'per event',gstRate:18 },
 { id:'dj_prem', name:'DJ – Premium', price:45000,unit:'per event',gstRate:18 },
 { id:'liveband', name:'Live Band', price:75000,unit:'per event',gstRate:18 },
 { id:'anchor', name:'Anchor / Emcee', price:15000,unit:'per event',gstRate:18 },
 { id:'raindance', name:'Rain Dance', price:8000, unit:'per event',gstRate:18 },
 ],
 fnb: [
 { id:'bar', name:'Bar Counter', price:35000,unit:'per event',gstRate:18 },
 { id:'mocktail', name:'Mocktail Counter',price:12000,unit:'per event',gstRate:18 },
 { id:'chaat', name:'Chaat Counter', price:8000, unit:'per event',gstRate:18 },
 { id:'dessert', name:'Dessert Counter',price:10000,unit:'per event',gstRate:18 },
 ],
 av: [
 { id:'projector', name:'Projector & Screen',price:5000, unit:'per day', gstRate:18 },
 { id:'led', name:'LED Screen', price:18000,unit:'per day', gstRate:18 },
 { id:'pa', name:'PA System', price:8000, unit:'per day', gstRate:18 },
 { id:'mics', name:'Wireless Mics ×4',price:3000,unit:'per day', gstRate:18 },
 ],
 decor: [
 { id:'stage', name:'Stage Setup', price:30000,unit:'per event',gstRate:18 },
 { id:'lighting', name:'Lighting Package',price:25000,unit:'per event',gstRate:18 },
 { id:'flowers', name:'Flower Decor', price:40000,unit:'per event',gstRate:18 },
 { id:'mandap', name:'Mandap Setup', price:60000,unit:'per event',gstRate:18 },
 ],
 media: [
 { id:'photo', name:'Photography', price:20000,unit:'per event',gstRate:18 },
 { id:'video', name:'Videography', price:30000,unit:'per event',gstRate:18 },
 { id:'branding', name:'Corporate Branding',price:12000,unit:'per event',gstRate:18 },
 ],
 },
};

// ─── ATOMS ───────────────────────────────────────────────────────────────────
const Card = ({ children, style = {} }) => (
 <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,.05)', ...style }}>
 {children}
 </div>
);

const Btn = ({ children, onClick, variant = 'primary', style = {}, disabled }) => {
 const v = {
 primary: { background: C.accent, color: '#fff', border: 'none' },
 ghost: { background: 'transparent', color: C.text2, border: `1px solid ${C.border2}` },
 danger: { background: C.red, color: '#fff', border: 'none' },
 amber: { background: C.amberBg, color: C.amber, border: `1px solid ${C.amberBorder}` },
 light: { background: C.accentLight, color: C.accent, border: 'none' },
 };
 return (
 <button onClick={onClick} disabled={disabled} style={{ ...v[variant], padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6, ...style }}>
 {children}
 </button>
 );
};

const PriceInput = ({ value, onChange, prefix = '₹', suffix }) => (
 <div style={{ display: 'flex', alignItems: 'center', background: C.bg, border: `1px solid ${C.border2}`, borderRadius: 8, overflow: 'hidden', minWidth: 120 }}>
 {prefix && <span style={{ padding: '7px 8px 7px 10px', fontSize: 12, color: C.text3, fontWeight: 600, background: '#EEF2EE', borderRight: `1px solid ${C.border}` }}>{prefix}</span>}
 <input
 type="number"
 value={value}
 onChange={e => onChange(Number(e.target.value))}
 style={{ flex: 1, padding: '7px 8px', border: 'none', background: 'transparent', fontSize: 13, fontWeight: 600, color: C.text, fontFamily: 'Inter,sans-serif', outline: 'none', minWidth: 60 }}
 />
 {suffix && <span style={{ padding: '7px 10px 7px 4px', fontSize: 11, color: C.text3 }}>{suffix}</span>}
 </div>
);

const SectionHeader = ({ title, icon, count, color = C.accent, bg = C.accentLight }) => (
 <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 20px', borderBottom: `1px solid ${C.border}`, background: bg }}>
 <span style={{ fontSize: 20 }}>{icon}</span>
 <div style={{ flex: 1 }}>
 <div style={{ fontSize: 14, fontWeight: 700, color }}>{title}</div>
 {count !== undefined && <div style={{ fontSize: 11, color: C.text3 }}>{count} items</div>}
 </div>
 </div>
);

const SaveToast = ({ visible }) => visible ? (
 <div style={{ position: 'fixed', bottom: 28, right: 28, background: C.accent, color: '#fff', padding: '12px 20px', borderRadius: 12, fontWeight: 600, fontSize: 14, boxShadow: '0 8px 32px rgba(58,175,88,.4)', zIndex: 999, display: 'flex', alignItems: 'center', gap: 8 }}>
 Prices saved successfully
 </div>
) : null;

// ─── TABS ────────────────────────────────────────────────────────────────────
const TABS = [
 { id: 'rooms', label: 'Room Rates', },
 { id: 'mealPlans', label: 'Meal Plans', },
 { id: 'packages', label: 'Packages', },
 { id: 'venues', label: 'Venues', },
 { id: 'activities', label: 'Activities', },
 { id: 'addons', label: 'Add-ons', },
];

// ─── PRICE CHANGE TRACKER ────────────────────────────────────────────────────
function PriceChangeLog({ changes }) {
 if (changes.length === 0) return null;
 return (
 <div style={{ background: C.amberBg, border: `1px solid ${C.amberBorder}`, borderRadius: 10, padding: '12px 16px', marginBottom: 16 }}>
 <div style={{ fontSize: 12, fontWeight: 700, color: C.amber, marginBottom: 8 }}> Unsaved Changes ({changes.length})</div>
 <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
 {changes.slice(0, 5).map((c, i) => (
 <span key={i} style={{ background:'#006b3c', border: `1px solid ${C.amberBorder}`, borderRadius: 6, padding: '3px 8px', fontSize: 11, color: C.amber }}>
 {c.name}: {inr(c.old)} → {inr(c.new)}
 </span>
 ))}
 {changes.length > 5 && <span style={{ fontSize: 11, color: C.amber }}>+{changes.length - 5} more</span>}
 </div>
 </div>
 );
}

// ─── ROOM RATES TABLE ────────────────────────────────────────────────────────
function RoomRatesTable({ data, onChange }) {
 return (
 <Card>
 <SectionHeader title="Room Type Base Rates" icon="" count={data.length} bg={C.blueBg} color={C.blue} />
 <div style={{ overflowX: 'auto' }}>
 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
 <thead>
 <tr style={{ background: '#F5F8F5' }}>
 {['Room Type','Base Rate / Night','Extra Bed / Night','GST Rate','Per Night (incl. GST)'].map(h => (
 <th key={h} style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em', textAlign: 'left', borderBottom: `1px solid ${C.border}` }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {data.map((room, i) => (
 <tr key={room.id} style={{ borderBottom: `1px solid ${C.border}`, background: i % 2 === 0 ? '#FAFCFA' : C.surface }}>
 <td style={{ padding: '12px 16px' }}>
 <div style={{ fontWeight: 600, fontSize: 13, color: C.text }}>{room.name}</div>
 </td>
 <td style={{ padding: '12px 16px' }}>
 <PriceInput value={room.baseRate} onChange={v => onChange(i, 'baseRate', v)} />
 </td>
 <td style={{ padding: '12px 16px' }}>
 <PriceInput value={room.extraBed} onChange={v => onChange(i, 'extraBed', v)} />
 </td>
 <td style={{ padding: '12px 16px' }}>
 <div style={{ display: 'flex', alignItems: 'center', background: C.bg, border: `1px solid ${C.border2}`, borderRadius: 8, overflow: 'hidden', width: 90 }}>
 <input type="number" value={room.gstRate} onChange={e => onChange(i, 'gstRate', Number(e.target.value))}
 style={{ flex: 1, padding: '7px 8px', border: 'none', background: 'transparent', fontSize: 13, fontWeight: 600, color: C.text, fontFamily: 'Inter,sans-serif', outline: 'none' }} />
 <span style={{ padding: '7px 10px 7px 2px', fontSize: 12, color: C.text3 }}>%</span>
 </div>
 </td>
 <td style={{ padding: '12px 16px' }}>
 <span style={{ fontWeight: 700, color: C.accent, fontSize: 15 }}>
 {inr(Math.round(room.baseRate * (1 + room.gstRate / 100)))}
 </span>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 <div style={{ padding: '12px 20px', borderTop: `1px solid ${C.border}`, background: C.accentLight, borderRadius: '0 0 12px 12px' }}>
 <div style={{ fontSize: 12, color: C.text3 }}>
 Extra Bed charges apply per night. GST 12% for tariff ₹7,500/night, 18% for above as per Indian GST rules.
 </div>
 </div>
 </Card>
 );
}

// ─── MEAL PLAN TABLE ─────────────────────────────────────────────────────────
function MealPlanTable({ data, onChange }) {
 return (
 <Card>
 <SectionHeader title="Meal Plan Rates" icon="" count={data.length} />
 <div style={{ overflowX: 'auto' }}>
 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
 <thead>
 <tr style={{ background: '#F5F8F5' }}>
 {['Meal Plan','Rate per Pax (₹)','GST @ 5%','Total per Pax'].map(h => (
 <th key={h} style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em', textAlign: 'left', borderBottom: `1px solid ${C.border}` }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {data.map((mp, i) => (
 <tr key={mp.id} style={{ borderBottom: `1px solid ${C.border}`, background: i % 2 === 0 ? '#FAFCFA' : C.surface }}>
 <td style={{ padding: '12px 16px', fontWeight: 600, fontSize: 13 }}>{mp.name}</td>
 <td style={{ padding: '12px 16px' }}>
 <PriceInput value={mp.ratePerPax} onChange={v => onChange(i, 'ratePerPax', v)} />
 </td>
 <td style={{ padding: '12px 16px', color: C.text3, fontSize: 13 }}>{inr(Math.round(mp.ratePerPax * 0.05))}</td>
 <td style={{ padding: '12px 16px', fontWeight: 700, color: C.accent, fontSize: 15 }}>{inr(Math.round(mp.ratePerPax * 1.05))}</td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </Card>
 );
}

// ─── PACKAGE TABLE ───────────────────────────────────────────────────────────
function PackageTable({ data, onChange }) {
 return (
 <Card>
 <SectionHeader title="Package Rates (Per Pax)" icon="" count={data.length} color={C.purple} bg={C.purpleBg} />
 <div style={{ overflowX: 'auto' }}>
 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
 <thead>
 <tr style={{ background: '#F5F8F5' }}>
 {['Package Name','Rate / Pax','GST','Total / Pax (incl. GST)','Inclusions'].map(h => (
 <th key={h} style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em', textAlign: 'left', borderBottom: `1px solid ${C.border}` }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {data.map((pkg, i) => (
 <tr key={pkg.id} style={{ borderBottom: `1px solid ${C.border}`, background: i % 2 === 0 ? '#FAFCFA' : C.surface }}>
 <td style={{ padding: '12px 16px' }}>
 <div style={{ fontWeight: 600, fontSize: 13 }}>{pkg.name}</div>
 </td>
 <td style={{ padding: '12px 16px' }}>
 <PriceInput value={pkg.ratePerPax} onChange={v => onChange(i, 'ratePerPax', v)} />
 </td>
 <td style={{ padding: '12px 16px' }}>
 <div style={{ display: 'flex', alignItems: 'center', background: C.bg, border: `1px solid ${C.border2}`, borderRadius: 8, overflow: 'hidden', width: 80 }}>
 <input type="number" value={pkg.gstRate} onChange={e => onChange(i, 'gstRate', Number(e.target.value))}
 style={{ flex: 1, padding: '7px 6px', border: 'none', background: 'transparent', fontSize: 13, fontWeight: 600, outline: 'none', fontFamily: 'Inter,sans-serif' }} />
 <span style={{ padding: '7px 8px 7px 2px', fontSize: 11, color: C.text3 }}>%</span>
 </div>
 </td>
 <td style={{ padding: '12px 16px', fontWeight: 700, color: C.accent, fontSize: 15 }}>
 {inr(Math.round(pkg.ratePerPax * (1 + pkg.gstRate / 100)))}
 </td>
 <td style={{ padding: '12px 16px' }}>
 <div style={{ fontSize: 11, color: C.text3, maxWidth: 220 }}>{pkg.includes}</div>
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </Card>
 );
}

// ─── VENUE TABLE ─────────────────────────────────────────────────────────────
function VenueTable({ data, onChange }) {
 return (
 <Card>
 <SectionHeader title="Venue & Lawn Rates" icon="" count={data.length} color={C.teal} bg={C.tealBg} />
 <div style={{ overflowX: 'auto' }}>
 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
 <thead>
 <tr style={{ background: '#F5F8F5' }}>
 {['Venue','Base Rate (₹)','Capacity (pax)','GST','Total (incl. GST)'].map(h => (
 <th key={h} style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em', textAlign: 'left', borderBottom: `1px solid ${C.border}` }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {data.map((v, i) => (
 <tr key={v.id} style={{ borderBottom: `1px solid ${C.border}`, background: i % 2 === 0 ? '#FAFCFA' : C.surface }}>
 <td style={{ padding: '12px 16px', fontWeight: 600, fontSize: 13 }}>{v.name}</td>
 <td style={{ padding: '12px 16px' }}><PriceInput value={v.baseRate} onChange={val => onChange(i, 'baseRate', val)} /></td>
 <td style={{ padding: '12px 16px' }}>
 <div style={{ display: 'flex', alignItems: 'center', background: C.bg, border: `1px solid ${C.border2}`, borderRadius: 8, overflow: 'hidden', width: 90 }}>
 <input type="number" value={v.capacity} onChange={e => onChange(i, 'capacity', Number(e.target.value))}
 style={{ flex: 1, padding: '7px 8px', border: 'none', background: 'transparent', fontSize: 13, fontWeight: 600, outline: 'none', fontFamily: 'Inter,sans-serif' }} />
 </div>
 </td>
 <td style={{ padding: '12px 16px', color: C.text3, fontSize: 13 }}>{v.gstRate}%</td>
 <td style={{ padding: '12px 16px', fontWeight: 700, color: C.accent, fontSize: 15 }}>
 {inr(Math.round(v.baseRate * (1 + v.gstRate / 100)))}
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </Card>
 );
}

// ─── ACTIVITY TABLE ──────────────────────────────────────────────────────────
function ActivityTable({ data, onChange }) {
 return (
 <Card>
 <SectionHeader title="Activity & Adventure Pricing" icon="" count={data.length} color={C.red} bg={C.redBg} />
 <div style={{ overflowX: 'auto' }}>
 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
 <thead>
 <tr style={{ background: '#F5F8F5' }}>
 {['Activity','Price / Pax','Capacity / Slot','Duration','GST','Total / Pax'].map(h => (
 <th key={h} style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em', textAlign: 'left', borderBottom: `1px solid ${C.border}` }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {data.map((act, i) => (
 <tr key={act.id} style={{ borderBottom: `1px solid ${C.border}`, background: i % 2 === 0 ? '#FAFCFA' : C.surface }}>
 <td style={{ padding: '12px 16px', fontWeight: 600, fontSize: 13 }}>{act.name}</td>
 <td style={{ padding: '12px 16px' }}><PriceInput value={act.pricePerPax} onChange={v => onChange(i, 'pricePerPax', v)} /></td>
 <td style={{ padding: '12px 16px' }}>
 <div style={{ display: 'flex', alignItems: 'center', background: C.bg, border: `1px solid ${C.border2}`, borderRadius: 8, overflow: 'hidden', width: 80 }}>
 <input type="number" value={act.capacity} onChange={e => onChange(i, 'capacity', Number(e.target.value))}
 style={{ flex: 1, padding: '7px 8px', border: 'none', background: 'transparent', fontSize: 13, fontWeight: 600, outline: 'none', fontFamily: 'Inter,sans-serif' }} />
 </div>
 </td>
 <td style={{ padding: '12px 16px', fontSize: 12, color: C.text3 }}>{act.duration}</td>
 <td style={{ padding: '12px 16px', fontSize: 13, color: C.text3 }}>{act.gstRate}%</td>
 <td style={{ padding: '12px 16px', fontWeight: 700, color: C.accent, fontSize: 15 }}>
 {inr(Math.round(act.pricePerPax * (1 + act.gstRate / 100)))}
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </Card>
 );
}

// ─── ADDONS TABLE ────────────────────────────────────────────────────────────
const ADDON_META = {
 adventure: { label: 'Adventure Activities', color: C.red, bg: C.redBg },
 entertainment: { label: 'Entertainment', color: C.purple, bg: C.purpleBg },
 fnb: { label: 'F&B Counters', color: C.teal, bg: C.tealBg },
 av: { label: 'AV & Technology', color: C.blue, bg: C.blueBg },
 decor: { label: 'Decor & Setup', color: C.amber, bg: C.amberBg },
 media: { label: 'Media & Branding', color: C.text2, bg: '#F0F4F0' },
};

function AddonsTable({ data, onChange }) {
 return (
 <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
 {Object.entries(data).map(([cat, items]) => {
 const meta = ADDON_META[cat] || { label: cat, color: C.accent, bg: C.accentLight };
 return (
 <Card key={cat}>
 <SectionHeader title={meta.label} icon={meta.icon} count={items.length} color={meta.color} bg={meta.bg} />
 <div style={{ overflowX: 'auto' }}>
 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
 <thead>
 <tr style={{ background: '#F5F8F5' }}>
 {['Add-on Name','Price (₹)','Billing Unit','GST','Total (incl. GST)'].map(h => (
 <th key={h} style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em', textAlign: 'left', borderBottom: `1px solid ${C.border}` }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {items.map((addon, i) => (
 <tr key={addon.id} style={{ borderBottom: `1px solid ${C.border}`, background: i % 2 === 0 ? '#FAFCFA' : C.surface }}>
 <td style={{ padding: '12px 16px', fontWeight: 600, fontSize: 13 }}>{addon.name}</td>
 <td style={{ padding: '12px 16px' }}>
 <PriceInput value={addon.price} onChange={v => onChange(cat, i, 'price', v)} />
 </td>
 <td style={{ padding: '12px 16px' }}>
 <select value={addon.unit} onChange={e => onChange(cat, i, 'unit', e.target.value)}
 style={{ padding: '7px 10px', background: C.bg, border: `1px solid ${C.border2}`, borderRadius: 8, fontSize: 12, color: C.text, fontFamily: 'Inter,sans-serif', cursor: 'pointer' }}>
 {['per pax','per event','per day','per hour','per setup'].map(u => <option style={{background:'#0F2040',color:'#F0F2FF'}} key={u}>{u}</option>)}
 </select>
 </td>
 <td style={{ padding: '12px 16px', fontSize: 13, color: C.text3 }}>{addon.gstRate}%</td>
 <td style={{ padding: '12px 16px', fontWeight: 700, color: meta.color, fontSize: 15 }}>
 {inr(Math.round(addon.price * (1 + addon.gstRate / 100)))}
 </td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </Card>
 );
 })}
 </div>
 );
}

// ─── MAIN PRICING MANAGER ────────────────────────────────────────────────────
export default function PricingManager() {
 const [activeTab, setActiveTab] = useState('rooms');
 const [prices, setPrices] = useState(() => {
 try {
 const saved = localStorage.getItem('botanix_prices');
 return saved ? JSON.parse(saved) : DEFAULT_PRICES;
 } catch { return DEFAULT_PRICES; }
 });
 const [changes, setChanges] = useState([]);
 const [showToast, setShowToast] = useState(false);
 const [hasChanges, setHasChanges] = useState(false);

 const trackChange = (name, oldVal, newVal) => {
 if (oldVal === newVal) return;
 setChanges(p => {
 const existing = p.findIndex(c => c.name === name);
 if (existing >= 0) { const n = [...p]; n[existing] = { name, old: n[existing].old, new: newVal }; return n; }
 return [...p, { name, old: oldVal, new: newVal }];
 });
 setHasChanges(true);
 };

 const updateRoom = (i, key, val) => {
 trackChange(`${prices.rooms[i].name} ${key}`, prices.rooms[i][key], val);
 setPrices(p => { const n = { ...p, rooms: [...p.rooms] }; n.rooms[i] = { ...n.rooms[i], [key]: val }; return n; });
 };
 const updateMeal = (i, key, val) => {
 trackChange(`${prices.mealPlans[i].name}`, prices.mealPlans[i][key], val);
 setPrices(p => { const n = { ...p, mealPlans: [...p.mealPlans] }; n.mealPlans[i] = { ...n.mealPlans[i], [key]: val }; return n; });
 };
 const updatePackage = (i, key, val) => {
 trackChange(`${prices.packages[i].name}`, prices.packages[i][key], val);
 setPrices(p => { const n = { ...p, packages: [...p.packages] }; n.packages[i] = { ...n.packages[i], [key]: val }; return n; });
 };
 const updateVenue = (i, key, val) => {
 trackChange(`${prices.venues[i].name}`, prices.venues[i][key], val);
 setPrices(p => { const n = { ...p, venues: [...p.venues] }; n.venues[i] = { ...n.venues[i], [key]: val }; return n; });
 };
 const updateActivity = (i, key, val) => {
 trackChange(`${prices.activities[i].name}`, prices.activities[i][key], val);
 setPrices(p => { const n = { ...p, activities: [...p.activities] }; n.activities[i] = { ...n.activities[i], [key]: val }; return n; });
 };
 const updateAddon = (cat, i, key, val) => {
 trackChange(`${prices.addons[cat][i].name}`, prices.addons[cat][i][key], val);
 setPrices(p => {
 const n = { ...p, addons: { ...p.addons, [cat]: [...p.addons[cat]] } };
 n.addons[cat][i] = { ...n.addons[cat][i], [key]: val };
 return n;
 });
 };

 const save = () => {
 try { localStorage.setItem('botanix_prices', JSON.stringify(prices)); } catch (e) {}
 setChanges([]);
 setHasChanges(false);
 setShowToast(true);
 setTimeout(() => setShowToast(false), 3000);
 };

 const reset = () => {
 if (window.confirm('Reset all prices to defaults?')) {
 setPrices(DEFAULT_PRICES);
 setChanges([]);
 setHasChanges(false);
 }
 };

 // Quick summary stats
 const avgRoomRate = Math.round(prices.rooms.reduce((s, r) => s + r.baseRate, 0) / prices.rooms.length);
 const totalAddons = Object.values(prices.addons).flat().length;

 return (
 <div style={{ fontFamily: 'Inter, sans-serif', color: C.text }}>
 <SaveToast visible={showToast} />

 {/* Top Bar */}
 <div style={{ background: C.surface, borderBottom: `1px solid ${C.border}`, padding: '0 28px', position: 'sticky', top: 0, zIndex: 50 }}>
 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 62 }}>
 <div>
 <div style={{ fontSize: 11, color: C.text3, fontWeight: 500, marginBottom: 1 }}>Settings — edit rates visible in all booking forms</div>
 <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 20, fontWeight: 800, color: C.text, letterSpacing: '-.02em' }}>Pricing Manager</div>
 </div>
 <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
 {hasChanges && (
 <div style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 12px', background: C.amberBg, border: `1px solid ${C.amberBorder}`, borderRadius: 8 }}>
 <span style={{ width: 7, height: 7, borderRadius: '50%', background: C.amber }} />
 <span style={{ fontSize: 12, fontWeight: 600, color: C.amber }}>{changes.length} unsaved change{changes.length !== 1 ? 's' : ''}</span>
 </div>
 )}
 <Btn variant="ghost" onClick={reset}>↺ Reset to Defaults</Btn>
 <Btn onClick={save} disabled={!hasChanges}> Save All Prices</Btn>
 </div>
 </div>
 </div>

 <div style={{ padding: '20px 28px' }}>
 {/* Summary Cards */}
 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 12, marginBottom: 20 }}>
 {[
 ['Room Types', prices.rooms.length, '', C.blueBg, C.blue],
 ['Avg Room Rate', inr(avgRoomRate), '₹', C.accentLight, C.accent],
 ['Meal Plans', prices.mealPlans.length, '', C.accentLight, C.accent],
 ['Packages', prices.packages.length, '', C.purpleBg, C.purple],
 ['Activities', prices.activities.length, '', C.redBg, C.red],
 ['Add-on Items', totalAddons, '', C.amberBg, C.amber],
 ].map(([label, value, icon, bg, color]) => (
 <div key={label} style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 11, padding: '14px 16px', boxShadow: '0 1px 3px rgba(0,0,0,.04)' }}>
 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
 <div style={{ fontSize: 10, fontWeight: 700, color: C.text3, textTransform: 'uppercase', letterSpacing: '.06em' }}>{label}</div>
 <div style={{ width: 28, height: 28, borderRadius: 8, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>{icon}</div>
 </div>
 <div style={{ fontFamily: 'Plus Jakarta Sans, sans-serif', fontSize: 20, fontWeight: 800, color }}>{value}</div>
 </div>
 ))}
 </div>

 <PriceChangeLog changes={changes} />

 {/* Tab Nav */}
 <div style={{ display: 'flex', gap: 4, marginBottom: 18, background: C.surface, border: `1px solid ${C.border}`, borderRadius: 10, padding: 4, flexWrap: 'wrap' }}>
 {TABS.map(t => (
 <button key={t.id} onClick={() => setActiveTab(t.id)}
 style={{ flex: 1, minWidth: 110, padding: '8px 12px', borderRadius: 8, border: 'none', cursor: 'pointer', background: activeTab === t.id ? C.accent : 'transparent', color: activeTab === t.id ? '#fff' : C.text3, fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, transition: 'all .15s' }}>
 {t.icon} {t.label}
 </button>
 ))}
 </div>

 {/* Tab Content */}
 {activeTab === 'rooms' && <RoomRatesTable data={prices.rooms} onChange={updateRoom} />}
 {activeTab === 'mealPlans' && <MealPlanTable data={prices.mealPlans} onChange={updateMeal} />}
 {activeTab === 'packages' && <PackageTable data={prices.packages} onChange={updatePackage} />}
 {activeTab === 'venues' && <VenueTable data={prices.venues} onChange={updateVenue} />}
 {activeTab === 'activities' && <ActivityTable data={prices.activities} onChange={updateActivity} />}
 {activeTab === 'addons' && <AddonsTable data={prices.addons} onChange={updateAddon} />}

 {/* Bottom save bar */}
 {hasChanges && (
 <div style={{ position: 'sticky', bottom: 20, marginTop: 20, background: C.text, borderRadius: 12, padding: '14px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 8px 32px rgba(0,0,0,.2)' }}>
 <div style={{ color: '#fff', fontSize: 13 }}>
 <span style={{ fontWeight: 600 }}>{changes.length} price change{changes.length !== 1 ? 's' : ''}</span> — remember to save before leaving this page.
 </div>
 <div style={{ display: 'flex', gap: 10 }}>
 <Btn variant="ghost" onClick={() => { setPrices(DEFAULT_PRICES); setChanges([]); setHasChanges(false); }} style={{ color: '#fff', borderColor: 'rgba(255,255,255,.3)' }}>Discard</Btn>
 <Btn onClick={save} style={{ background: C.accent }}> Save All Prices</Btn>
 </div>
 </div>
 )}
 </div>
 </div>
 );
}
